import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CocktailWrapperScreen } from './CocktailWrapperScreen';
import { DeleteDataButton } from './DialogueDataSaving/PensionProgressSaver';
import { SummaryDisclosure } from './DisclosureUnits/SummaryDisclosure';
import { BackButton } from './NavigationButtons';
import { Button } from '../../general/Button';
import { RobotEnvironmentContext } from '../../../contexts/general/RobotEnvironmentContext';
import { usePostDialogueData } from '../../../api/pension-robot/usePostPensionDialogueData';
import { SaveMarketingModal } from './DialogueDataSaving/SaveMarketingModal';
import { SaveMyBNDModal } from './DialogueDataSaving/SaveMyBNDModal';

export const SummarySection = () => {
    const { t } = useTranslation('pension');
    const { environment } = useContext(RobotEnvironmentContext);

    const FinishButton = () => {
        if (environment === 'Marketing') return <SaveMarketingButton />;
        if (environment === 'MyBND') return <SaveMyBNDButton />;
        return <></>;
    };

    return (
        <CocktailWrapperScreen
            page={6}
            isColorGoal
            title={t('pension-cocktail-fill-screen-summary-title')}
            isResultsScreen={true}
        >
            <SummaryDisclosure />
            <div className="flex flex-row flex-wrap my-10 items-start gap-4">
                <BackButton />
                <FinishButton />
            </div>
            <DeleteDataButton />
        </CocktailWrapperScreen>
    );
};

const SaveMarketingButton = () => {
    const { t } = useTranslation('pension');
    const [saveMarketingModalShown, setSaveMarketingModalShown] = useState<boolean>(false);
    const query = usePostDialogueData();

    const onClick = () => setSaveMarketingModalShown(true);

    const onSaveData = () => query !== undefined && query.refetch();

    return (
        <>
            <Button buttonType="primary" onClick={onClick} className={`h-10 px-8`}>
                {t('general-save-result-page')}
            </Button>
            <SaveMarketingModal
                isShown={saveMarketingModalShown}
                setIsShown={setSaveMarketingModalShown}
                onSaveData={onSaveData}
            />
        </>
    );
};

const SaveMyBNDButton = () => {
    const { t } = useTranslation('pension');
    const [saveMyBNDModalShown, setSaveMyBNDModalShown] = useState<boolean>(false);

    const onClick = () => setSaveMyBNDModalShown(true);

    return (
        <>
            <Button buttonType="primary" onClick={onClick} className={`h-10 px-8`}>
                {t('general-save-MyBND-summary-page')}
            </Button>
            <SaveMyBNDModal isShown={saveMyBNDModalShown} setIsShown={setSaveMyBNDModalShown} />
        </>
    );
};
